import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import axios from 'axios';
import useAppStore from "../appStore";
import { useNavigate } from 'react-router-dom';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import WorkIcon from '@mui/icons-material/Work';

const Dashboard = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [ordersCount, setOrdersCount] = useState(0);
    const [postsCount, setPostsCount] = useState(0);
    const [earnings, setEarnings] = useState(0);
    const { token } = useAppStore();


    useEffect(() => {
        fetchDashboardData();
    }, []);

    const fetchDashboardData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/seller-dashboard`,
                {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Content-type": "Application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const { users, orders, posts, categories, totalEarning } = response.data;

            // Update the state with fetched data
            setOrdersCount(orders || 0);
            setPostsCount(posts || 0);
            setEarnings(totalEarning || 0);

        } catch (error) {
            console.error("Error fetching dashboard data:", error);
        }
    };

    return (
        <div className="p-4">
            <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12 min-h-[88vh]">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        {/* Total Posts */}
                        <div
                            className={`rounded-lg flex justify-center cursor-pointer p-2 shadow-md min-h-[100px] ${isDarkMode ? 'bg-gray-800' : 'bg-gray-100'}`}
                            onClick={() => {
                                navigate('/posts')
                            }}
                        >
                            <div className="flex">
                                <div className="bg-blue-100 rounded-full my-5 p-5">
                                    <WorkIcon className="text-blue-500" />
                                </div>
                                <div className="ml-5 mt-6">
                                    <div className="font-semibold">
                                        <span className="text-xl">{postsCount}</span>
                                    </div>
                                    <div className="text-xs text-slate-500 font-semibold">
                                        Posts
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Total Orders */}
                        <div
                            className={`rounded-lg flex justify-center cursor-pointer p-2 shadow-md min-h-[100px] ${isDarkMode ? 'bg-gray-800' : 'bg-gray-100'}`}
                            onClick={() => {
                                navigate('/orders')
                            }}
                        >
                            <div className="flex">
                                <div className="bg-cyan-100 rounded-full my-5 p-5">
                                    <Inventory2Icon className="text-cyan-500" />
                                </div>
                                <div className="ml-5 mt-6">
                                    <div className="font-semibold">
                                        <span className="text-xl">{ordersCount}</span>
                                    </div>
                                    <div className="text-xs text-slate-500 font-semibold">
                                        Orders
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Total Earnings */}
                        <div
                            className={`rounded-lg flex justify-center cursor-pointer p-2 shadow-md min-h-[100px] ${isDarkMode ? 'bg-gray-800' : 'bg-gray-100'}`}
                        >
                            <div className="flex">
                                <div className="bg-green-100 rounded-full my-5 p-5">
                                    <CreditScoreIcon className="text-green-500" />
                                </div>
                                <div className="ml-5 mt-6">
                                    <div className="font-semibold">
                                        <span className="text-xl">{earnings}</span>
                                    </div>
                                    <div className="text-xs text-slate-500 font-semibold">
                                        Earnings
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Dashboard;
